/* eslint-disable ts/no-unsafe-assignment, ts/no-unsafe-member-access */
import type { AnyFieldApi } from '@tanstack/react-form'
import type { ApiErrorBody } from '@/api/client'
import { formatFieldErrors } from '@/components/forms/field-errors'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface FormInputProps {
  field: AnyFieldApi
  label: string
  type?: string
  placeholder?: string
  autoComplete?: string
  description?: string
  serverErrors?: ApiErrorBody['errors']
}

export function FormInput({
  field,
  label,
  type = 'text',
  placeholder,
  autoComplete,
  description,
  serverErrors,
}: FormInputProps) {
  const errors = formatFieldErrors(field.state.meta.errors)
  const serverMessages = serverErrors?.[field.name] ?? []
  const allErrors = [...errors, ...serverMessages]

  return (
    <div className="space-y-2">
      {label !== '' && <Label htmlFor={field.name}>{label}</Label>}
      <Input
        id={field.name}
        name={field.name}
        type={type}
        placeholder={placeholder}
        autoComplete={autoComplete}
        value={field.state.value ?? ''}
        onBlur={field.handleBlur}
        onChange={(e) => field.handleChange(e.target.value)}
        aria-invalid={allErrors.length > 0}
        aria-describedby={allErrors.length > 0 ? `${field.name}-error` : undefined}
      />
      {description !== undefined && description !== '' && (
        <p className="text-muted-foreground text-sm">{description}</p>
      )}
      {allErrors.length > 0 && (
        <p id={`${field.name}-error`} className="text-destructive text-sm">
          {allErrors.join(', ')}
        </p>
      )}
    </div>
  )
}
